// src/redux/reducers/errorLog.reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { requestLogs } from '../actions/logsRequest.actions';
import SingleState from '../states/single.state';

const initialState: SingleState = {
  data: null,
  loading: false,
  error: null,
};

const LogsRequestSlice = createSlice({
  name: 'requestLogs',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestLogs.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(requestLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'An error occurred';
      });
  },
});

export const { clearError } = LogsRequestSlice.actions;
export default LogsRequestSlice.reducer;